// extracted by mini-css-extract-plugin
export default {"container":"CheckBox_container__K9tTp","checkbox":"CheckBox_checkbox__2r37K","checkIcon":"CheckBox_checkIcon__RzCLl","labelText":"CheckBox_labelText__Y-bKc"};